import styled from "styled-components";

export const FormWrapperSC = styled.div`
  display: flex;
  flex-direction: column;
`;
